//ClassDetails.js
import React, { useEffect, useState, useRef, useContext  } from "react";
import { useNavigate, useLocation} from 'react-router-dom';
import styled from "styled-components";
import ButtonMobile from "../../components/ButtonMobile/ButtonMobile";
import ButtonBack from "../../components/ButtonMobile/ButtonBack";
import Calender from "../../components/Calender/Calender";
import ButtonUploadPayment from "../../components/ButtonMobile/ButtonUploadPayment";
import { TitleHeader } from "../../globalStyles";
import Cookies from 'js-cookie';
import axios from "axios";
import { AuthContext } from "../../context/authContext";
import { HistoryContext } from '../../context/historyContext';
import MessageModal from "../../components/Modal/Modal.jsx";
import ButtonAddChild from "../../components/ButtonMobile/ButtonAddChild";
import {AddUserMemberForm} from "../../components/Form/Form";
import {ConsentCheckbox} from "../../components/Form/ConsentCheckbox";
import api from '../../Api'; // adjust the path based on where api.js is located



import {  LoadingOverlay,
  LoadingSpinner,
} from "../../globalStyles.js";



import {
  FormContainer,
  Input,
  FormFeedback
} from "../../pages/loginpages/LoginStyles";



export const ClassCard = ({programInfo, classInfo, orderDetails}) => {
  const navigate = useNavigate()

    const { currentUser, loading } = useContext(AuthContext);

    const [student, setStudent] = useState(null)
    const [contact, setContact] = useState(null);
    const [additionalInfo, setAdditionalInfo] = useState({});
    const [errors, setErrors] = useState({});
    const [userMember, setUserMember] = useState([]);

    // Initialize mandatory selections when orderDetails is available
    useEffect(() => {
      if (orderDetails?.course_additional_info_fields?.fields) {
        console.log('Initializing additionalInfo with orderDetails:', orderDetails);
        const fields = orderDetails.course_additional_info_fields.fields;
        
        // Initialize all fields that have mandatory options
        const newAdditionalInfo = {};
        fields.forEach(field => {
          if (field.type === 'radio-group' && field.options) {
            const mandatoryOptions = field.options.filter(opt => opt.required);
            if (mandatoryOptions.length > 0) {
              console.log(`Found mandatory options for ${field.name}:`, mandatoryOptions);
              // Use Set to ensure unique values
              const uniqueValues = [...new Set(mandatoryOptions.map(opt => opt.value))];
              newAdditionalInfo[field.name] = uniqueValues;
            }
          }
        });
        
        // Set all mandatory selections at once
        setAdditionalInfo(prev => ({
          ...prev,
          ...newAdditionalInfo
        }));
        console.log('Initialized additionalInfo:', newAdditionalInfo);
      }
    }, [orderDetails]);

const [isFormInitialized, setIsFormInitialized] = useState(false);

useEffect(() => {
  const initializeStudent = () => {
      if (userMember?.length > 0) {
        const { first_name, last_name, dateofbirth, gender } = userMember[0];
        if (programInfo?.requireConsent) {
          setStudent({
            firstname: first_name,
            lastname: last_name,
            dob: dateofbirth,
            gender: gender,
            disclaimerConsent: ""
          });
        } else {
          setStudent({
            firstname: first_name,
            lastname: last_name,
            dob: dateofbirth,
            gender: gender
          });
        }
      } else {
        if (programInfo?.requireConsent) {
          setStudent({
            firstname: "",
            lastname: "",
            dob: "",
            gender: "",
            disclaimerConsent: ""
          });
        } else {
          setStudent({
            firstname: "",
            lastname: "",
            dob: "",
            gender: ""
          });
        }
      }
    };


  const initializeContact = () => {
      const initialContact = [...Array(8)].reduce((acc, _, index) => {
        acc[`mobile-${index}`] = '';
        return acc;
      }, { email: '', mobile:'' });

      if (programInfo?.requirePayment) {
        initialContact.payment = '';
      }

      setContact(initialContact);
    };

    const initializeForm = () => {
      initializeStudent();
      initializeContact();
      setIsFormInitialized(true);
    };

    initializeForm();


}, [programInfo,userMember]); // Run this effect when courseId changes



	// Regular expression for email validation
	const emailRegex = /\S+@\S+\.\S+/;
  const mobileRegex =/^\d{8}$/;


const validateFormData = () => {

  let newErrors = {};
  // Validate student data
  for (let key in student) {
    if (student[key] === "" || student[key] == null || student[key] == undefined || student[key] == false) {
      newErrors[key] = "This field is required";
    } else if (key === "dob") {
      const dob = new Date(student.dob);
      const today = new Date();
      const minDate = new Date("1920-01-01");
        const year = dob.getFullYear();

      if (isNaN(year)) {
        newErrors.dob = "Invalid date";
      } else if (year < 1920 || dob > new Date()) {
        newErrors.dob = "Date of birth must be between year 1920 and today";
      }
    }
  }

  // Validate additional info fields
  if (classInfo?.additionalInfoFields) {
    classInfo.additionalInfoFields.forEach(field => {
      // Handle multiple select and radio-group with required options
      if ((field.type === 'select' && field.multiple) || field.type === 'radio-group') {
        const selectedValues = additionalInfo[field.name] || [];
        const requiredOptions = field.options.filter(opt => opt.required);
        
        // Check minimum selections
        if (field.min_selections && selectedValues.length < field.min_selections) {
          newErrors[field.name] = `Please select at least ${field.min_selections} options`;
        }

        // Check required options
        requiredOptions.forEach(option => {
          if (!selectedValues.includes(option.value)) {
            newErrors[field.name] = newErrors[field.name] || `${option.label} is required`;
          }
        });
      }
      // Handle regular required fields
      else if (field.required && (!additionalInfo[field.name] || additionalInfo[field.name] === "")) {
        newErrors[field.name] = "This field is required";
      } 
      // Handle regex validation
      else if (additionalInfo[field.name] && field.validation_regex) {
        const regex = new RegExp(field.validation_regex);
        if (!regex.test(additionalInfo[field.name])) {
          newErrors[field.name] = field.validation_message || "Invalid format";
        }
      }
    });
  }

  // Validate contact data
  for (let key in contact) {
    if (contact[key] === "" || contact[key] == null || contact[key] == undefined) {
      newErrors[key] = "This field is required";
    } else {
      if (key === "email" && !emailRegex.test(contact[key])) {
        newErrors["email"] = "Invalid email format";
      }
      if (key === "mobile" && !mobileRegex.test(contact[key])) {
        newErrors["mobile"] = "Mobile number has to be in 8 digits long and only numbers";
      }
    }
  }

  setErrors(newErrors);
  return Object.keys(newErrors).length === 0;
};




    const [tab, setTab] = useState(null);
      const [image, setImage] = useState(null);
      	const [modalOpen, setModalOpen] = useState(false);
        const [autoClose, setAutoClose] = useState(true);
	const [modalTemplate, setModalTemplate] = useState("");
    const [loadingCircle, setLoadingCircle] = useState(false);
  const [files, setFiles] = useState(null); //Handle Upload Photos
    const [uploadDir, setUploadDir] = useState(null);
        const [submitImage, setSubmitImage] = useState(null);


  const fileInputRef = useRef(null);

  const handleButtonClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();

    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
          setSubmitImage(file);
    const reader = new FileReader();

    reader.onloadend = () => {
      // Here you can handle the preview of the image
      console.log(reader.result);
            setImage(reader.result);

    };

    if (file) {
      reader.readAsDataURL(file);
    }
  };


useEffect(() => {
       let activeCourseFromCookie = Cookies.get('activeCourse');
  if (!loading && programInfo?.requireLogin && !currentUser) {
    navigate('/en/login'); // replace '/login' with your actual login route
  } else if (!activeCourseFromCookie){
 navigate(history); // r
  }
}, [programInfo, currentUser]);


// console.log(student)
// console.log(contact)


  const host = window.location.hostname;
const subdomain = host.split('.')[0];
const shopName = subdomain;
const { history, setHistory } = useContext(HistoryContext);


  useEffect(() => {
 const savedHistory = localStorage.getItem('history');
  if (savedHistory) {
    setHistory(JSON.parse(savedHistory));
  }

	

		const fetchData = async () => {
			try {
				const res = await api.get(
					`/classBooking/api/user/getUserMembers`,{
            withCredentials: true,
        }
				);
				setUserMember(res.data);
          setTab(res.data[0].id)
			} catch (err) {
				console.log(err);
			}
		};

		fetchData();
		// setResultChange("All");

		// const intervalId = setInterval(fetchData, 1000);

		// Clean up the interval when the component unmounts or when dependencies change
		// return () => {
		// 	clearInterval(intervalId);
		// };
	}, []);



  const handleChange = (event) => {
    const { name, value, files, type, options } = event.target;
    console.log('handleChange:', { name, value, type });

    // Handle payment file upload
    if (name === "payment") {
      setContact((prevFormData) => ({
        ...prevFormData,
        [name]: files[0],
      }));
      return;
    }

    // Handle additional info fields
    if (orderDetails?.course_additional_info_fields?.fields?.some(field => field.name === name)) {
      console.log('Handling additional info field:', name);
      
      // Handle multiple select
      if (type === 'select-multiple') {
        const selectedOptions = Array.from(options)
          .filter(option => option.selected)
          .map(option => option.value);
        
        console.log('Multiple select:', { name, selectedOptions });
        setAdditionalInfo(prev => ({
          ...prev,
          [name]: selectedOptions
        }));
        return;
      }

      // Handle radio-group (using checkbox)
      if (type === 'checkbox') {
        const currentValues = additionalInfo[name] || [];
        let newValues;
        
        if (event.target.checked) {
          // Add value if not already present
          newValues = currentValues.includes(value) ? currentValues : [...currentValues, value];
        } else {
          // Remove value if not required
          const field = orderDetails.course_additional_info_fields.fields.find(f => f.name === name);
          const option = field?.options?.find(opt => opt.value === value);
          if (!option?.required) {
            newValues = currentValues.filter(v => v !== value);
          } else {
            // Don't allow unchecking required option
            return;
          }
        }
        
        console.log('Radio group:', { name, currentValues, newValues });
        setAdditionalInfo(prev => ({
          ...prev,
          [name]: newValues
        }));
        return;
      }

      // Handle other field types
      console.log('Regular field:', { name, value });
      setAdditionalInfo(prev => ({
        ...prev,
        [name]: value
      }));
      return;
    }

    // Handle contact fields
    setContact((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };


console.log(additionalInfo)

const openModalConsent = (template, e)=> {
   e.preventDefault(); // Prevent the checkbox from being checked
		setModalOpen(true);
		setModalTemplate(template);
    setAutoClose(false)
  }


const SubmitOrder = async () => {
    const isValid = validateFormData();

    if (isValid) {
    setLoadingCircle(true);

try {


const formData = new FormData();

if (programInfo.requirePayment) {
  formData.append('photos', submitImage); // 'photos' is the name of the field
}

// Log available data
console.log('Available data for order details:', {
  orderDetails,
  classInfo,
  programInfo
});

// Log available data for debugging
console.log('Building order details from:', {
  orderDetails,
  classInfo,
  programInfo,
  additionalInfo
});

// Log available data for enrichment
console.log('Data for enrichment:', {
  orderDetails,
  classInfo,
  programInfo,
  additionalInfo
});

// Log the data we're using to calculate quantity
console.log('Quantity calculation data:', {
  classInfo,
  requireSelection: classInfo.requireSelection,
  selectedDates: orderDetails.selectedDates,
  selectedClassIds: orderDetails.selectedClassIds,
  orderDetailsQuantity: orderDetails.quantity
});

// Log data sources for enrichment
console.log('Data sources for enrichment:', {
  orderDetails: {
    fee: orderDetails.fee,
    courseCode: orderDetails.courseCode
  },
  classInfo: {
    fee: classInfo.fee,
    code: classInfo.code,
    courseCode: classInfo.courseCode
  }
});

// Clean up order details and add additionalInfo
const enrichedOrderDetails = {
  id: orderDetails.id,
  fee: orderDetails.fee || classInfo.fee || classInfo.totalPrice,  // Added totalPrice as fallback
  venue: orderDetails.venue || classInfo.venue,
  shopId: orderDetails.shopId,
  // For courses that don't allow selection, quantity is always 1
  // For courses that allow selection, quantity is the number of selected classes
  quantity: classInfo.requireSelection ? 
    (orderDetails.selectedDates?.length || orderDetails.selectedClassIds?.length || 1) : 1,
  venue_chi: orderDetails.venue_chi,
  courseCode: orderDetails.courseCode || classInfo.courseCode || classInfo.code,  // Try all possible fields
  totalPrice: orderDetails.totalPrice || classInfo.fee || classInfo.totalPrice,  // Added totalPrice as fallback
  programName: orderDetails.programName || programInfo?.name,
  option1value: orderDetails.option1value || classInfo.course_option1value,  // Try orderDetails first
  option2value: orderDetails.option2value || classInfo.course_option2value,  // Try orderDetails first
  selectedDates: orderDetails.selectedDates || 
    (classInfo.classes?.filter(c => orderDetails.selectedClassIds?.includes(c.id))
      .map(c => ({
        id: c.id,
        date: c.date,
        name: c.name
      }))) || [],
  additionalInfo: additionalInfo,  // Add the additionalInfo
  programNameChi: orderDetails.programNameChi || programInfo?.name_chi,
  option1value_chi: orderDetails.option1value_chi || classInfo.option1value_chi,
  option2value_chi: orderDetails.option2value_chi || classInfo.option2value_chi
};

// Log the enriched order details
console.log('Enriched order details:', enrichedOrderDetails);

// Log final order details
console.log('Final enriched order details:', enrichedOrderDetails);

// Log the values we're specifically looking for
console.log('Option values:', {
  course_option1value: classInfo.course_option1value,
  course_option2value: classInfo.course_option2value,
  final_option1value: enrichedOrderDetails.option1value,
  final_option2value: enrichedOrderDetails.option2value
});

formData.append('orderDetails', JSON.stringify(enrichedOrderDetails));
formData.append('contact', JSON.stringify(contact));
formData.append('student', JSON.stringify(student));
formData.append('status', Number(!programInfo.requireConfirmBooking));

  const data = {
  orderDetails: JSON.stringify(enrichedOrderDetails),
  contact: JSON.stringify(contact),
  student: JSON.stringify(student),
};

				const res = await api.post(
					`/classBooking/api/orders`,
				formData,{ withCredentials: true, headers: {
    'Content-Type': 'multipart/form-data',
  },});

        if (res.status === 200) {

  // Add orderId to enrichedOrderDetails for the email
  enrichedOrderDetails.orderId = res.data.orderId;
  enrichedOrderDetails.token = res.data.token;

  console.log('Order created with ID:', res.data.orderId)


if (currentUser){

	const res = await api.post(
					`/classBooking/api/user/addUserMember`,
					student,{   withCredentials: true,}
				);
}

// if (programInfo.requirePayment) {
//             // Upload the imag

//           const formData = new FormData();


//   formData.append('photos', submitImage); // 'image' is the name of the field
// //   // Submit the form data and the image
//   const response = await api.post(`/classBooking/api/orders/uploadReceipt?orderId=${res.data.orderId}`, formData, {   withCredentials: true,});

 
  
//     if (response.status === 200) {


// if (programInfo.requirePayment) {

const emailData = {
  recipientEmail: contact.email, // replace with actual recipient email
  orderDetails: enrichedOrderDetails, // use the data you submitted before
  student: {
    firstname: student.firstname, 
    lastname: student.lastname, 
    dob: student.dob, 
    gender: student.gender
  },
  language:"en"
};

if(programInfo?.requireConfirmBooking){
  // Send confirmation email out
  const sendOutEmail = await api.post(`/classBooking/api/orders/emailConfirmationEmail`, emailData, {   withCredentials: true,});

  } else {

 const sendTicket = await api.post(`/classBooking/api/orders/sendTicket`, emailData , {   withCredentials: true,});

  }
  // Send confirmation email out
  const emailOrderEmailNotice = await api.post(`/classBooking/api/orders/emailOrderEmailNotice`, emailData, {   withCredentials: true,});


  }


//     // Add student
//   const addStudent = await axios.post(`http://${shopName}.booking.dynevents.local:8089/classBooking/api/student/add`, emailData, {   withCredentials: true,});


        // Clean up course cookie
        Cookies.remove('activeCourse');

        setLoadingCircle(false);
				setModalOpen(true);
				setModalTemplate("success");
        console.log(programInfo.requireConfirmBooking)
        
				setTimeout(() => {
					navigate(`/en/order/${res.data.token}`);
				}, 3000);

      // }

			} catch (err) {
       console.error('Error submitting order:', err);       
     
				setModalOpen(true);
				setModalTemplate("fail");
				setTimeout(() => {
					  navigate(history);
				}, 3000);
			}
    }
}

  const handleMobileChange = (index, e) => {
    const value = e.target.value.replace(/[^0-9]/g, '') || ''; // Ensure empty string if no value
    setContact((prevContact) => {
      const mobileArray = Array.from({ length: 8 }).map((_, i) => 
        i === index ? value : (prevContact[`mobile-${i}`] || '')
      );
      return {
        ...prevContact,
        [`mobile-${index}`]: value,
        mobile: mobileArray.join('')
      };
    });

    if (value && index < 7) {
      document.getElementById(`mobile-${index + 1}`).focus();
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === 'Backspace' && !e.target.value && index > 0) {
      document.getElementById(`mobile-${index - 1}`).focus();
    }
  };


  return (
    <>
      <PageContainer>
        <PageHeader>
          <BackButton onClick={() => navigate(-1)}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M19 12H5M5 12L12 19M5 12L12 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </BackButton>
          <PageTitle>Complete Booking</PageTitle>
          <div style={{ width: 40 }}></div>
        </PageHeader>

        {/* Order Summary Section */}
        <ModernSection>
          <SectionHeader $color="blue">
            <SectionIconWrapper $color="blue">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 5H7C5.89543 5 5 5.89543 5 7V19C5 20.1046 5.89543 21 7 21H17C18.1046 21 19 20.1046 19 19V7C19 5.89543 18.1046 5 17 5H15" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5C15 6.10457 14.1046 7 13 7H11C9.89543 7 9 6.10457 9 5Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </SectionIconWrapper>
            <SectionTitle>Order Summary</SectionTitle>
          </SectionHeader>
          <SectionContent>
            <OrderSummaryCard>
              <CourseCodeBadge>{orderDetails?.courseCode || classInfo?.courseCode || classInfo?.code}</CourseCodeBadge>
              <OrderCourseName>{programInfo?.name}</OrderCourseName>
              
              <OrderDetailsGrid>
                {orderDetails?.option1value && (
                  <OrderDetailItem>
                    <OrderDetailLabel>Option</OrderDetailLabel>
                    <OrderDetailValue>{orderDetails?.option1value}</OrderDetailValue>
                  </OrderDetailItem>
                )}
                {orderDetails?.option2value && (
                  <OrderDetailItem>
                    <OrderDetailLabel>Selection</OrderDetailLabel>
                    <OrderDetailValue>{orderDetails?.option2value}</OrderDetailValue>
                  </OrderDetailItem>
                )}
                <OrderDetailItem>
                  <OrderDetailLabel>Total Classes</OrderDetailLabel>
                  <OrderDetailValue>
                    {classInfo?.classes?.filter(classItem => orderDetails?.selectedClassIds?.includes(classItem.id))?.length || orderDetails?.quantity || classInfo?.noofclasses}
                  </OrderDetailValue>
                </OrderDetailItem>
              </OrderDetailsGrid>

              {classInfo?.classes?.filter(classItem => orderDetails?.selectedClassIds?.includes(classItem.id))?.length > 0 && (
                <SelectedDatesContainer>
                  <SelectedDatesTitle>Selected Class Dates:</SelectedDatesTitle>
                  <SelectedDatesList>
                    {classInfo?.classes
                      ?.filter(classItem => orderDetails?.selectedClassIds?.includes(classItem.id))
                      ?.map((classDate, index) => (
                        <SelectedDateItem key={index}>
                          <DateBullet />
                          <span>{new Date(classDate.date).toLocaleDateString()} - {classDate.name}</span>
                        </SelectedDateItem>
                      ))}
                  </SelectedDatesList>
                </SelectedDatesContainer>
              )}

              <PriceSummary>
                <PriceLabel>Total Amount</PriceLabel>
                <PriceValue>
                  {classInfo?.fee === "0" ? 'Free' : `HK$ ${orderDetails?.totalPrice || classInfo?.fee}`}
                </PriceValue>
              </PriceSummary>
            </OrderSummaryCard>
          </SectionContent>
        </ModernSection>

{/* Participant Info Section */}
        <ModernSection>
          <SectionHeader $color="purple">
            <SectionIconWrapper $color="purple">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </SectionIconWrapper>
            <SectionTitle>Participant Info</SectionTitle>
          </SectionHeader>
          <SectionContent>
            {programInfo?.requireLogin && currentUser ? (
              userMember.length > 0 ? (
                <MemberCardsContainer>
                  {userMember?.map((info, index) => {
                    const dateOfBirth = new Date(info.dateofbirth);
                    const formattedDateOfBirth = dateOfBirth.toLocaleDateString();

                    return (
                      <MemberCard 
                        key={info.id}
                        $active={tab === info.id} 
                        onClick={() => { 
                          setStudent({ 
                            firstname: info.first_name,
                            lastname: info.last_name,
                            dob: dateOfBirth,
                            gender: info.gender
                          });
                          setTab(info.id);
                        }}
                      >
                        <MemberAvatar $active={tab === info.id}>
                          {info.first_name?.charAt(0)}{info.last_name?.charAt(0)}
                        </MemberAvatar>
                        <MemberInfo>
                          <MemberName>{info.first_name} {info.last_name}</MemberName>
                          <MemberDetails>
                            <span>{formattedDateOfBirth}</span>
                            <MemberDot />
                            <span>{info.gender}</span>
                          </MemberDetails>
                        </MemberInfo>
                        {tab === info.id && (
                          <MemberCheck>
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M5 13L9 17L19 7" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                          </MemberCheck>
                        )}
                      </MemberCard>
                    )
                  })}
                </MemberCardsContainer>
              ) : (
                <AddUserMemberForm formData={student} setFormData={setStudent} withSubmitBtn={false} errors={errors} language={"en"}/>
              )
            ) : ( 
              <AddUserMemberForm formData={student} setFormData={setStudent} withSubmitBtn={false} errors={errors} language={"en"}/>
            )}
          </SectionContent>
        </ModernSection>

{orderDetails?.course_additional_info_fields?.fields && orderDetails.course_additional_info_fields.fields.length > 0 && (
  <ModernSection>
    <SectionHeader $color="orange">
      <SectionIconWrapper $color="orange">
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 8V12M12 16H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </SectionIconWrapper>
      <SectionTitle>Additional Info</SectionTitle>
    </SectionHeader>
    <SectionContent>
    <FormContainer>
      {orderDetails.course_additional_info_fields.fields.map((field, index) => (
        <MobileInputContainer key={index}>
          <MobileInputTitle>
            {field.label} {field.required && '*'}
          </MobileInputTitle>
          
          {field.type === 'select' && (
            <>
              <Select
                required={field.required}
                name={field.name}
                value={additionalInfo[field.name] || ''}
                onChange={handleChange}
                multiple={field.multiple}
              >
                {!field.multiple && <option value="">Select {field.label}</option>}
                {field.options?.map((option, idx) => (
                  <option 
                    key={idx} 
                    value={option.value}
                    required={option.required}
                  >
                    {option.label} {option.required ? '*' : ''}
                  </option>
                ))}
              </Select>
              {field.multiple && field.options?.some(opt => opt.required) && (
                <Note style={{ fontSize: '12px', marginTop: '5px' }}>
                  * Required option
                </Note>
              )}
            </>
          )}

          {field.type === 'textarea' && (
            <TextArea
              required={field.required}
              name={field.name}
              value={additionalInfo[field.name] || ''}
              onChange={handleChange}
              placeholder={field.placeholder}
            />
          )}

          {field.type === 'radio-group' && (
            <>
              <TournamentNote>
                <strong>Important Note:</strong> {field.note}
              </TournamentNote>
              <RequiredNote>
                * Please select at least {field.min_selections} options
              </RequiredNote>
              <RadioGroup>
                {field.options?.map((option, idx) => (
                  <RadioLabel key={idx} required={option.required}>
                    <input
                      type="checkbox"
                      name={field.name}
                      value={option.value}
                      checked={(additionalInfo[field.name] || []).includes(option.value)}
                      onChange={(e) => {
                        const currentValues = additionalInfo[field.name] || [];
                        let newValues;
                        
                        if (option.required && !e.target.checked) {
                          // Prevent unchecking mandatory option
                          return;
                        }
                        
                        newValues = e.target.checked
                          ? [...currentValues, option.value]
                          : currentValues.filter(v => v !== option.value);
                        
                        console.log('Updating field:', {
                          field: field.name,
                          currentValues,
                          newValues,
                          event: e.target.checked
                        });
                        
                        setAdditionalInfo(prev => ({
                          ...prev,
                          [field.name]: newValues
                        }));
                      }}
                      disabled={option.required} // Disable checkbox for mandatory option
                      required={option.required}
                    />
                    <RadioButtonStyle />
                    <OptionContent>
                      <OptionTitle>
                        {option.label} {option.required && ' *'}
                      </OptionTitle>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        {option.date && (
                          <OptionDate>
                            {option.date}
                          </OptionDate>
                        )}
                        {option.status && (
                          <OptionStatus>
                            {option.status}
                          </OptionStatus>
                        )}
                      </div>
                      {option.availability && (
                        <OptionAvailability>
                          {option.availability}
                        </OptionAvailability>
                      )}
                    </OptionContent>
                  </RadioLabel>
                ))}
              </RadioGroup>
            </>
          )}

          {field.type === 'checkbox' && (
            <CheckboxGroup>
              {field.options?.map((option, idx) => (
                <CheckboxLabel key={idx}>
                  <input
                    type="checkbox"
                    name={field.name}
                    value={option.value}
                    checked={additionalInfo[field.name]?.includes(option.value)}
                    onChange={(e) => {
                      const currentValues = additionalInfo[field.name] || [];
                      const newValues = e.target.checked
                        ? [...currentValues, option.value]
                        : currentValues.filter(v => v !== option.value);
                      handleChange({
                        target: {
                          name: field.name,
                          value: newValues
                        }
                      });
                    }}
                  />
                  {option.label}
                </CheckboxLabel>
              ))}
            </CheckboxGroup>
          )}

          {(field.type === 'text' || field.type === 'number' || field.type === 'email') && (
            <Input
              required={field.required}
              type={field.type}
              placeholder={field.placeholder || field.label}
              name={field.name}
              value={additionalInfo[field.name] || ''}
              onChange={handleChange}
              pattern={field.validation_regex}
            />
          )}

          {errors[field.name] && (
            <FormFeedback>{errors[field.name]}</FormFeedback>
          )}
        </MobileInputContainer>
      ))}
    </FormContainer>
    </SectionContent>
  </ModernSection>
)}

        {/* Contact Info Section */}
        <ModernSection>
          <SectionHeader $color="teal">
            <SectionIconWrapper $color="teal">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M22 16.92V19.92C22.0011 20.1985 21.9441 20.4742 21.8325 20.7294C21.7209 20.9845 21.5573 21.2136 21.3521 21.4019C21.1469 21.5901 20.9046 21.7335 20.6408 21.8227C20.3769 21.9119 20.0974 21.9451 19.82 21.92C16.7428 21.5856 13.787 20.5341 11.19 18.85C8.77382 17.3147 6.72533 15.2662 5.18999 12.85C3.49997 10.2412 2.44824 7.271 2.11999 4.18C2.095 3.90347 2.12787 3.62476 2.21649 3.36162C2.30512 3.09849 2.44756 2.85669 2.63476 2.65162C2.82196 2.44655 3.0498 2.28271 3.30379 2.17052C3.55777 2.05833 3.83233 2.00027 4.10999 2H7.10999C7.5953 1.99522 8.06579 2.16708 8.43376 2.48353C8.80173 2.79999 9.04207 3.23945 9.10999 3.72C9.23662 4.68007 9.47144 5.62273 9.80999 6.53C9.94454 6.88792 9.97366 7.27691 9.8939 7.65088C9.81415 8.02485 9.62886 8.36811 9.35999 8.64L8.08999 9.91C9.51355 12.4135 11.5765 14.4765 14.08 15.9L15.35 14.63C15.6219 14.3611 15.9651 14.1758 16.3391 14.0961C16.7131 14.0163 17.1021 14.0455 17.46 14.18C18.3673 14.5185 19.3099 14.7534 20.27 14.88C20.7558 14.9485 21.1996 15.1932 21.5177 15.5673C21.8359 15.9414 22.0057 16.4187 22 16.92Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </SectionIconWrapper>
            <SectionTitle>Contact Info</SectionTitle>
          </SectionHeader>
          <SectionContent>
          <FormContainer>
                      {/* <Note>Require valid HK Mobile for WhatsApp Communication</Note>
    <Input
              required
              type="text"
              placeholder="Mobile Contact for WhatsApp confirmation"
              name="mobile"
              onChange={handleChange}
            /> */}


  <MobileInputContainer>
              <MobileInputTitle>
                Require valid HK Mobile for WhatsApp Communication. Hong Kong
                Mobile (+852)
              </MobileInputTitle>
              <MobileInputWrapper>
                {Array.from({ length: 8 }).map((_, index) => (
                  <ThinInput
                    required
                    key={index}
                    type="tel"
                    maxLength="1"
                    name={`mobile-${index}`}
                    value={contact ? contact[`mobile-${index}`] || "" : ""}
                    onChange={(e) => handleMobileChange(index, e)}
                    onKeyDown={(e) => handleKeyDown(index, e)}
                    pattern="[0-9]*"
                    id={`mobile-${index}`}
                  />
                ))}
              </MobileInputWrapper>
            </MobileInputContainer>


               {errors.mobile && (
        <FormFeedback>{errors.mobile}</FormFeedback>
      )}

     <Note>Require valid Email for booking confirmation</Note>
              <Input
              required
              type="text"
              placeholder="Email"
              name="email"
              onChange={handleChange}
            />
              {errors.email && (
        <FormFeedback>{errors.email}</FormFeedback>
      )}

  {/* <Note>Kindly take a screenshot of the confirmation page for reference, also please note an SMS message reminder will be received a day prior your booking day. </Note> */}
    
{programInfo?.requireConsent ? (
<>
{/* <ConsentCheckbox formData={student} setFormData={setStudent} language={"en"} template={"photoConsent"}/> */}
 {/* {errors.photoConsent&& (
        <FormFeedback>{errors.photoConsent}</FormFeedback>
      )} */}
<ConsentCheckbox formData={student} setFormData={setStudent} language={"en"} template={"disclaimerConsent"} content={programInfo?.disclaimer_en} onClick={(e)=>openModalConsent("disclaimerConsent", e)}  requireModalConsent={true}/>
 {errors.disclaimerConsent&& (
        <FormFeedback>{errors.disclaimerConsent}</FormFeedback>
      )}

</>) : (null)  }

          </FormContainer>
          </SectionContent>
        </ModernSection>


{programInfo?.requirePayment ? (
      <PaymentSection>
        <PaymentHeader>
          <PaymentIcon>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M21 4H3C1.89543 4 1 4.89543 1 6V18C1 19.1046 1.89543 20 3 20H21C22.1046 20 23 19.1046 23 18V6C23 4.89543 22.1046 4 21 4Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M1 10H23" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </PaymentIcon>
          <PaymentTitle>Payment Method</PaymentTitle>
        </PaymentHeader>
        
        <PaymentContent>
          <PaymentMethodLabel>Pay via FPS or Bank Transfer</PaymentMethodLabel>
          
          <PaymentDetailsCard>
            <PaymentDetailRow>
              <PaymentDetailLabel>FPS ID</PaymentDetailLabel>
              <PaymentDetailValue>112492855</PaymentDetailValue>
            </PaymentDetailRow>
            <PaymentDivider />
            <PaymentDetailRow>
              <PaymentDetailLabel>Bank Account</PaymentDetailLabel>
              <PaymentDetailValue>OCBC Bank 829-4414-26051</PaymentDetailValue>
            </PaymentDetailRow>
            <PaymentDivider />
            <PaymentDetailRow>
              <PaymentDetailLabel>Account Name</PaymentDetailLabel>
              <PaymentDetailValue>Empire Sports Limited (035)</PaymentDetailValue>
            </PaymentDetailRow>
          </PaymentDetailsCard>

          <PaymentChecklist>
            <ChecklistTitle>Please ensure your receipt shows:</ChecklistTitle>
            <ChecklistItem>
              <ChecklistIcon>✓</ChecklistIcon>
              <span>Your bank account number</span>
            </ChecklistItem>
            <ChecklistItem>
              <ChecklistIcon>✓</ChecklistIcon>
              <span>Payment date</span>
            </ChecklistItem>
            <ChecklistItem>
              <ChecklistIcon>✓</ChecklistIcon>
              <span>Amount paid</span>
            </ChecklistItem>
          </PaymentChecklist>

          {errors.payment && (
            <FormFeedback>{errors.payment}</FormFeedback>
          )}

          <input
            type="file"
            accept="image/*"
            name="payment"
            onChange={(e) => {
              handleFileChange(e);
              handleChange(e);
            }}
            style={{ display: 'none' }}
            ref={fileInputRef}
            id="file"
          />

          <UploadWrapper>
            <ButtonUploadPayment
              status="uploadedMessage"
              onClick={handleButtonClick}
              uploadedFile={submitImage}
            />
          </UploadWrapper>
          
          {image && (
            <ImagePreviewWrapper>
              <ImagePreviewLabel>Preview:</ImagePreviewLabel>
              <ImagePreview src={image} alt="Payment proof preview" />
            </ImagePreviewWrapper>
          )}
        </PaymentContent>
      </PaymentSection>
) : (null)  } 
           

        <ModernFooter>
          <ConfirmButton onClick={SubmitOrder}>
            <span>Confirm Booking</span>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </ConfirmButton>
        </ModernFooter>
      </PageContainer>

      {modalOpen && (
				<MessageModal
					isOpen={modalOpen}
					template={modalTemplate}
          language={"en"}
					autoClose={autoClose}
          setModalOpen={setModalOpen}
          formData={student}
          setFormData={setStudent}
          content={programInfo?.disclaimer_en}
				/>
			)}
        {/*************************************** 
            // LOADING CIRCLE //
        ***************************************/}
            {loadingCircle && (
              <LoadingOverlay>
                <LoadingSpinner />
              </LoadingOverlay>
            )}
    </>
  );
};

export const ClassConfirmPayment = () => {
  

    const navigate = useNavigate()
    const location = useLocation();

const { history, setHistory } = useContext(HistoryContext);
  const [classInfo, setClassInfo] = useState(null);
  const [orderDetails, setOrderDetails] = useState(null);
  const [programInfo, setProgramInfo] = useState(null);

useEffect(() => {
  const activeCourseStr = Cookies.get('activeCourse');
  
  if (activeCourseStr) {
    let parsedData;
    try {
      parsedData = JSON.parse(activeCourseStr);
      if (!parsedData?.course?.id) {
        console.error('Invalid course data in cookie');
        navigate(history);
        return;
      }
    } catch (err) {
      console.error('Error parsing cookie data:', err);
      navigate(history);
      return;
    }

    const program_code = parsedData.program;
    
    // Fetch program data and course details
    const fetchData = async () => {
      try {
        // Fetch program data
        const programRes = await api.get(`/classBooking/api/class/${program_code}`);
        setProgramInfo(programRes.data);
        
        // Fetch course details including additional info fields and classes
        const courseRes = await api.get(`/classBooking/api/class/course/${parsedData.course.id}`);
        console.log('Course details from backend:', courseRes.data);
        console.log('Original parsed data:', parsedData);
        
        // Log the specific fields we need
        console.log('Course option values:', {
          course_option1value: courseRes.data.course_option1value,
          course_option2value: courseRes.data.course_option2value,
          option1value: courseRes.data.option1value,
          option2value: courseRes.data.option2value,
          parsedDataCourse: parsedData.course
        });
        
        // Log the raw response data
        console.log('Raw API response:', {
          data: courseRes.data,
          option1value: courseRes.data.option1value,
          option2value: courseRes.data.option2value,
          course_option1value: courseRes.data.course_option1value,
          course_option2value: courseRes.data.course_option2value
        });
        
        // Set complete course info from backend
        setClassInfo(courseRes.data);
        
        // Log the raw data
        console.log('Raw course data:', courseRes.data);
        
        // Log raw course data for debugging
        console.log('Raw course data for order details:', {
          courseRes: courseRes.data,
          parsedData
        });

        // Set order details
        const orderDetails = {
          id: courseRes.data.id,
          courseCode: courseRes.data.courseCode || courseRes.data.code,  // Try both fields
          fee: courseRes.data.fee || parsedData.course.fee,  // Try both sources
          option1value: courseRes.data.option1value || courseRes.data.course_option1value,  // Try both fields
          option2value: courseRes.data.option2value || courseRes.data.course_option2value,  // Try both fields
          option1value_chi: courseRes.data.option1value_chi,
          option2value_chi: courseRes.data.option2value_chi,
          programName: courseRes.data.programName || courseRes.data.program_name,  // Added fallback
          shopId: courseRes.data.shopId || courseRes.data.shop_id,  // Added fallback
          venue: courseRes.data.venue,
          programNameChi: courseRes.data.programNameChi || courseRes.data.program_name_chi,  // Added fallback
          venue_chi: courseRes.data.venue_chi,
          // For courses that don't allow selection, quantity is always 1
          // For courses that allow selection, quantity is the number of selected classes
          quantity: courseRes.data.requireSelection ? 
            (parsedData.selectedClassIds?.length || 1) : 1,
          selectedClassIds: courseRes.data.requireSelection ? parsedData.selectedClassIds : courseRes.data.course_classes_id,
          totalPrice: parsedData.totalPrice || courseRes.data.fee,
          course_additional_info_fields: courseRes.data.course_additional_info_fields
        };

        // Log the created order details for verification
        console.log('Created order details:', {
          courseCode: orderDetails.courseCode,
          fee: orderDetails.fee,
          source: {
            courseCode: {
              fromCourseRes: courseRes.data.courseCode,
              fromCode: courseRes.data.code
            },
            fee: {
              fromCourseRes: courseRes.data.fee,
              fromParsedData: parsedData.course.fee
            }
          }
        });
        
        // Log the order details being set
        console.log('Setting order details:', {
          raw: courseRes.data,
          option1value: courseRes.data.option1value,
          option2value: courseRes.data.option2value,
          course_option1value: courseRes.data.course_option1value,
          course_option2value: courseRes.data.course_option2value,
          final: orderDetails
        });
        
        // Log the processed order details
        console.log('Processed order details:', orderDetails);
        
        setOrderDetails(orderDetails);
      } catch (err) {
        console.error('Error fetching data:', err);
        navigate(history);
      }
    };
    
    fetchData();

	const fetchProgramData = async () => {
			try {
				const res = await api.get(
					`/classBooking/api/class/${program_code}`
				);

		
			setProgramInfo(res.data);
          

			} catch (err) {
				console.log(err);
			}
		};

		fetchProgramData();

  } else {
  navigate(history);
    }
},[]);



useEffect(() => {
  if (classInfo && programInfo) {
    const { code: courseCode, fee, option1value, option2value, id, option1value_chi, option2value_chi } = classInfo;
    
    // Get the course info data
    const courseInfo = Cookies.get('activeCourseInfo');
    if (!courseInfo) return;
    
    const parsedInfo = JSON.parse(courseInfo);
    const { quantity, selectedClassIds, totalPrice } = parsedInfo;
    
    // If no quantity is set, use the default from classInfo
    const finalQuantity = quantity || classInfo?.noofclasses;
    const finalPrice = totalPrice || fee;

    // Map the selectedClassIds to the full class details from activeCourse.classes
    const selectedDates = selectedClassIds?.map(classId => {
      const classDetails = classInfo.classes?.find(c => c.id === classId);
      return classDetails ? {
        id: classDetails.id,
        date: classDetails.date,
        name: classDetails.name
      } : null;
    }).filter(Boolean) || [];

    const order_details = {
      id,
      courseCode,
      fee,
      option1value,
      option2value,
      option1value_chi,
      option2value_chi,
      programName: programInfo?.name,
      shopId: programInfo?.shop_id,
      venue: programInfo?.venue,
      programNameChi: programInfo?.name_chi,
      venue_chi: programInfo?.venue_chi,
      quantity: finalQuantity,
      selectedDates: selectedDates,
      totalPrice: finalPrice
    };

    setOrderDetails(order_details);
    console.log('Updated order details:', order_details);
  } 
}, [programInfo, classInfo]);
 

  return (
    <>
        <ClassCard classInfo={classInfo} orderDetails={orderDetails}  programInfo={programInfo}/>
    </>
  );
};
export default ClassConfirmPayment;

//STYLED-COMPONENTS:
export const CardContent = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  min-height: 100vh;
  padding-bottom: 100px;
`;

export const ButtonWrapper = styled.div`
  position: absolute;
  top: 22px;
  left: 22px;
  z-index: 10;
`;

export const NoteTitle = styled.div`
  font: 800 32px Lora, sans-serif;
  text-align: center; // Center text
  margin-top: 20px;
  margin-bottom: 0px; // Adjust spacing after title
  color: #0c729e;
  font-style: italic;
`;

export const Note = styled.div`
  // font-weight: 800;
  font-size:15px;
  text-align: left; // Center text
  margin-top: 0px;
  margin-bottom: 0px; // Adjust spacing after title
  color: #0c729e;
width:100%;
  
`;

export const NoteHighlight = styled.div`
 font-weight: 800;
  font-size:15px;
  text-align: center; // Center text
  margin-top: 0px;
  margin-bottom: 0px; // Adjust spacing after title
  color: #0c729e;
  border:3px solid orange;
  padding:5px;
  width:100%;
`;




export const ClassInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center; //CENTER THE CONTENT TO MAKE UPLOAD COMPONENT IN THE MIDDLE
  background-color: #ffffff;
  text-align:left;
  width: 100%;
  padding: 10px 10px;
  // border-radius: 0 0 20px 20px;
  border-bottom: 15px solid lightgrey;
`;


export const ClassTitleWrapper = styled.div`
width:100%;
text-align:left;

`

export const ClassTitle = styled.h1`
  // border: solid black 1px;
  // background-color: #fff;
  // max-width: 400px;
  height: auto;
  font: 700 18px Poppins, sans-serif;
  text-align: left; // Center text
  margin: 10px 0;
  width:100%;
  // padding: 0 20px;
`;

export const ClassDetailsStyled = styled.div`
  // display: grid;
  // grid-template-columns: 1fr 3fr; // Defines two columns: 1st column is 1/4th, 2nd column is 3/4ths of the total width
  // gap: 10px; // Gap between grid items
  width: 100%; //Makes the grid 80% of the width of the parent container
  padding-bottom: 10px;
`;

export const DetailItem = styled.div`
  display: contents; // Makes the container behave like a direct child of the grid container
`;

// export const DetailLabel = styled.span`
//   color: var(--Text-Muted, gray);
//   font-family: Poppins, sans-serif;
//   font-size: 14px;
//   font-weight: 600;
//   color: #eee;
// `;

export const DetailValue = styled.div`
  font-family: Lora, sans-serif;
  width:100%;
  color: black;
  font-weight: 500;
  font-size: 16px;
  // text-decoration: underline;
  font-style: italic;
`;

const FooterWrapper = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  border-radius: 12px 12px 0 0;
  background-color: var(--color-white);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  padding: 11px;
  gap: 20px;
  z-index: 1000;
  box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.1); // Very thin drop shadow
  @media (min-width: 500px) {
    width: 500px; /* Apply max-width constraint */
    left: calc((100vw - 500px) / 2);
    right: calc((100vw - 500px) / 2);
  }
`;

export const InputForm = styled.form`
  /* border: solid red 3px; */
  padding: 0px 20px 0px 20px;
  margin: 0;
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 10px;
`;

export const InputBoxWrapper = styled.div`
  align-self: stretch;
  border-radius: var(--br-12xl-5);
  background-color: var(--color-whitesmoke);
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0px var(--padding-mini) 0px var(--padding-base);
`;

export const InputBox = styled.input`
  height: 63px;
  flex: 1;
  position: relative;
  font-size: var(--font-size-lg);
  font-family: var(--font-poppins);
  color: var(--color-gray);
  text-align: left;
  display: flex;
  align-items: flex-start;
  z-index: 1;
  background-color: transparent;
  border: none;
  outline: none;
  padding: 0 var(--padding-mini);
  border-radius: var(--br-12xl-5);
  &:focus {
    outline: none;
  }
`;


export const Label = styled.div`
  font: 15px Lora, sans-serif;
  text-align: center; // Center text
  // margin-bottom: 20px; // Adjust spacing after venue
  // border:1px solid red;
  background-color:lightgrey;
  color:black;
  border-radius:2px;
  padding:2px 5px;
 width:25%;

`;

export const OptionListPrice = styled.div`
	// width: 100%;
	// margin: 10px auto;
  text-align:left;
  font-size:20px;
  font-weight:800;
`;


export const Subheader = styled.div`
  font-weight: 700;
  font-size: 20px;
  // text-align: left; // Center text
  margin-top: 10px; // Adjust spacing after venue
  margin-bottom:20px;
  // display:flex;
  // align-items:center;
  // justify-content:flex-start;
  border-left:10px solid rgb(0,0,139);
  width:100%;
  color:black;
  padding-left:20px;
  

`;


export const OptionListContainer = styled.div`
  position: relative;
	width: 100%;
	max-width: 978px;
	margin: 0px auto;
	padding: 5px 0;
	// margin-bottom: 15px;
	// border:10px solid blue;
	height: 220px;
	display: flex;
	align-items: center;
	justify-content: flex-start;
      gap: 10px;
	background-color: none;
  overflow: auto !important; // enable horizontal scrolling
  // margin-bottom:20px;
  
  

	position: sticky; // Add this line
	// top: 0; // And this line
	z-index: 999;

  /* Hide scrollbar for Chrome, Safari and Opera */
  &::-webkit-scrollbar {
    display: none;
  }

  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */


	// @media (max-width: 576px) {
	// 	margin: 0;
	// 	padding: 0px 0px 30px 0px;
	// }
`;

export const OptionList = styled.button`
  display:flex;
  flex-direction:column;
  align-items:center;
  justify-content:center;
	// width: 300px;
	border: 2px solid rgba(0, 0, 0, 0.1);
  width: 200px;
  height: 200px;
  border-radius: 50%;
	// height: 100%;
	background-color:#ffffff;
	color: rgba(0, 0, 0, 1);
	font-size: clamp(18px, 2vw, 2rem);
	min-width: 200px;
	padding: 10px 10px;
	cursor: pointer;
	transition: all 0.3s ease-in-out;

	//Acts like an 'active' tab
	border: ${(props) =>
		props.$active
			? "3px solid rgba(255, 133, 89, 1)"
			: "2px solid rgba(0, 0, 0, 0.1)"};

	background-color:${(props) =>
		props.$active
			? "rgba(255, 133, 89, 0.3)"
			: "#ffffff"};

`;



export const DynamicallyChangeContent = styled.div`
  text-align: left; // Center text
  // margin-bottom: 20px; // Adjust spacing after venue
  // border:1px solid red;
  // background-color:rgba(0,0,0,0.5);
  color:black;
  // padding:2px 5px;
  width:100%;
    height:100%;
    position:absolute;
    

   ul {
    list-style-type: disc; // Use disc for bullet points
    padding-left: 20px; // Add some padding to indent the list
      font-size:18px;
    
  }

`;

export const DynamicallyChangeContentContainer =styled.div`
display: flex;
overflow: hidden; /* Add this to hide the components that are off-screen */
width: 100%;
background-color:rgba(	255, 242, 237,1);
  border-radius:15px;
  	padding: 10px 10px;
    // border:1px solid red;
    // min-height:100px;
    height:200px;
      position: relative;
  margin-top:20px;


`

export const OptionListTopContainer = styled.div`
	// flex: 2;
	display:flex;
  flex-direction:column;
  align-items:flex-start;
  justify-content:flex-start;
	// border: 1px solid blue;
`;

export const OptionListMiddleContainer = styled.div`
color:grey;
font-size:15px;
text-align:left;
	// border: 1px solid blue;
`;

export const OptionListIconContainer = styled.div`
	flex: 1;
	width: 100%;
	// border: 1px solid red;

	svg {
		width: 30%;
		fill: #ffffff;
	}
`;

export const OptionListTitle = styled.div`
	width: 100%;
	margin: 10px auto;
  text-align:left;
  font-size:20px;
  font-weight:600;
`;


export const ImageContainer = styled.div`
	width: 50%;
	margin: 10px auto;

img{

width:100%;

}
`;

// ***RICK CHU 2021-09-29 for Mobile Input
export const MobileInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

export const MobileInputTitle = styled.div`
  text-align: left;
  font-size: clamp(1.8rem, 2vw, 2rem);
  color: #6b7180;
  margin-bottom: 1rem;
  width: 100%;
`;

export const MobileInputWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
  width: 100%;
  gap: 6px;
`;


export const ThinInput = styled.input`
  width: calc(100% / 8);
  min-width: 30px;
  height: 60px;
  text-align: center;
  font-size: 1.8rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  outline: none;

  &:focus {
    border-color: #77dffb;
  }

  @media (max-width: 400px) {
    width: 12%;
    min-width: 25px;
    height: 48px;
    font-size: 1.6rem;
  }
`;

const DateList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 5px 0;
`;

const DateItem = styled.li`
  padding: 5px 0;
  border-bottom: 1px solid #eee;
  color: #666;
  font-size: 14px;
  &:last-child {
    border-bottom: none;
  }
`;

const Select = styled.select`
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 16px;
  &:focus {
    outline: none;
    border-color: #007bff;
  }
  
  /* Styling for multiple select */
  &[multiple] {
    height: auto;
    min-height: 120px;
    option {
      padding: 8px;
      margin: 2px 0;
      border-radius: 2px;
      
      &:checked {
        background: #e6f3ff;
        color: #007bff;
      }
      
      &[required] {
        font-weight: bold;
        &::after {
          content: " *";
          color: red;
        }
      }
    }
  }
`;

const TextArea = styled.textarea`
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 16px;
  min-height: 100px;
  resize: vertical;
  &:focus {
    outline: none;
    border-color: #007bff;
  }
`;

const RadioGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const RadioButtonStyle = styled.span`
  position: relative;
  display: inline-block;
  width: 24px;
  height: 24px;
  margin-right: 12px;
  border: 2px solid #2196F3;
  border-radius: 50%;
  transition: all 0.2s ease;
  
  &:after {
    content: '';
    position: absolute;
    display: none;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: #2196F3;
    transition: all 0.2s ease;
  }
`;

const RadioLabel = styled.label`
  display: flex;
  align-items: flex-start;
  padding: 12px 16px;
  cursor: pointer;
  font-size: 16px;
  user-select: none;
  background: ${props => props.required ? '#EDF7FF' : '#fff'};
  border-radius: 8px;
  margin: 4px 0;
  transition: all 0.2s ease;
  border: 1px solid ${props => props.required ? '#1976D2' : '#e0e0e0'};

  input {
    position: absolute;
    opacity: 0;
    cursor: ${props => props.required ? 'not-allowed' : 'pointer'};
    height: 0;
    width: 0;
    
    &:checked ~ ${RadioButtonStyle}:after {
      display: block;
    }

    &:checked ~ ${RadioButtonStyle} {
      border-color: #1976D2;
    }

    &:checked ~ div {
      color: #1976D2;
    }

    &:disabled ~ ${RadioButtonStyle} {
      border-color: #1976D2;
      background: ${props => props.required ? '#EDF7FF' : '#fff'};
    }

    &:disabled ~ div {
      color: #1976D2;
      font-weight: 600;
    }
  }

  &:hover {
    background: ${props => props.required ? '#EDF7FF' : '#F5F5F5'};
    ${RadioButtonStyle} {
      border-color: #1976D2;
    }
  }
`;

const OptionContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex: 1;
`;

const OptionTitle = styled.span`
  font-weight: 500;
  color: #333;
  font-size: 16px;
`;

const OptionDate = styled.span`
  font-size: 14px;
  color: #666;
  display: flex;
  align-items: center;
  gap: 8px;

  &:before {
    content: '📅';
    font-size: 14px;
  }
`;

const OptionStatus = styled.span`
  font-size: 14px;
  color: #ff9800;
  font-style: italic;
`;

const OptionAvailability = styled.span`
  font-size: 13px;
  color: #2196F3;
  background: #e3f2fd;
  padding: 4px 8px;
  border-radius: 4px;
  display: inline-block;
  margin-top: 2px;

  &:before {
    content: '👥';
    margin-right: 4px;
  }
`;

const RequiredNote = styled.div`
  color: #d32f2f;
  font-size: 14px;
  margin-bottom: 12px;
  font-style: italic;
`;

const TournamentNote = styled.div`
  background: #e3f2fd;
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 16px;
  font-size: 14px;
  color: #1976D2;
  line-height: 1.5;

  strong {
    color: #1565C0;
  }
`;

const CheckboxGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const CheckboxLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 16px;
`;

// Modern Payment Section Styles
const PaymentSection = styled.div`
  margin: 16px;
  background: white;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
`;

const PaymentHeader = styled.div`
  background: linear-gradient(135deg, #1a73e8 0%, #0d5bba 100%);
  padding: 20px 24px;
  display: flex;
  align-items: center;
  gap: 14px;
`;

const PaymentIcon = styled.div`
  width: 44px;
  height: 44px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const PaymentTitle = styled.h2`
  font-family: 'Poppins', sans-serif;
  font-size: 18px;
  font-weight: 700;
  color: white;
  margin: 0;
`;

const PaymentContent = styled.div`
  padding: 24px;
`;

const PaymentMethodLabel = styled.p`
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  color: #6b7280;
  margin: 0 0 16px 0;
  text-align: center;
`;

const PaymentDetailsCard = styled.div`
  background: linear-gradient(135deg, #fef9e7 0%, #fef3c7 100%);
  border: 2px solid #f59e0b;
  border-radius: 16px;
  padding: 20px;
  margin-bottom: 20px;
`;

const PaymentDetailRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
`;

const PaymentDetailLabel = styled.span`
  font-family: 'Poppins', sans-serif;
  font-size: 13px;
  color: #92400e;
  font-weight: 500;
`;

const PaymentDetailValue = styled.span`
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  color: #78350f;
  font-weight: 700;
`;

const PaymentDivider = styled.div`
  height: 1px;
  background: rgba(245, 158, 11, 0.3);
  margin: 4px 0;
`;

const PaymentChecklist = styled.div`
  background: #f9fafb;
  border-radius: 12px;
  padding: 16px 20px;
  margin-bottom: 20px;
`;

const ChecklistTitle = styled.p`
  font-family: 'Poppins', sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  margin: 0 0 12px 0;
`;

const ChecklistItem = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 0;
  font-family: 'Poppins', sans-serif;
  font-size: 13px;
  color: #4b5563;
`;

const ChecklistIcon = styled.span`
  width: 20px;
  height: 20px;
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 700;
`;

const UploadWrapper = styled.div`
  width: 100%;
`;

const ImagePreviewWrapper = styled.div`
  margin-top: 20px;
  text-align: center;
`;

const ImagePreviewLabel = styled.p`
  font-family: 'Poppins', sans-serif;
  font-size: 12px;
  color: #6b7280;
  margin: 0 0 10px 0;
`;

const ImagePreview = styled.img`
  max-width: 200px;
  max-height: 200px;
  border-radius: 12px;
  border: 2px solid #e5e7eb;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
`;

// ============================================
// MODERN PAGE STYLES
// ============================================

const PageContainer = styled.div`
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #e4e8ec 100%);
  padding-bottom: 100px;
`;

const PageHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  background: white;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
  position: sticky;
  top: 0;
  z-index: 100;
`;

const BackButton = styled.button`
  width: 40px;
  height: 40px;
  border: none;
  background: #f3f4f6;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #374151;

  &:hover {
    background: #e5e7eb;
    transform: scale(1.05);
  }
`;

const PageTitle = styled.h1`
  font-family: 'Poppins', sans-serif;
  font-size: 18px;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0;
`;

const ModernSection = styled.div`
  margin: 16px;
  background: white;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
`;

const SectionHeader = styled.div`
  background: ${props => {
    switch(props.$color) {
      case 'blue': return 'linear-gradient(135deg, #1a73e8 0%, #0d5bba 100%)';
      case 'purple': return 'linear-gradient(135deg, #8b5cf6 0%, #6d28d9 100%)';
      case 'orange': return 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)';
      case 'teal': return 'linear-gradient(135deg, #14b8a6 0%, #0d9488 100%)';
      case 'green': return 'linear-gradient(135deg, #10b981 0%, #059669 100%)';
      default: return 'linear-gradient(135deg, #1a73e8 0%, #0d5bba 100%)';
    }
  }};
  padding: 18px 24px;
  display: flex;
  align-items: center;
  gap: 14px;
`;

const SectionIconWrapper = styled.div`
  width: 42px;
  height: 42px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const SectionTitle = styled.h2`
  font-family: 'Poppins', sans-serif;
  font-size: 17px;
  font-weight: 700;
  color: white;
  margin: 0;
`;

const SectionContent = styled.div`
  padding: 24px;
`;

// Order Summary Styles
const OrderSummaryCard = styled.div`
  background: linear-gradient(135deg, #fafbfc 0%, #f3f4f6 100%);
  border-radius: 16px;
  padding: 20px;
`;

const CourseCodeBadge = styled.span`
  display: inline-block;
  padding: 6px 14px;
  background: linear-gradient(135deg, #1a73e8 0%, #0d5bba 100%);
  color: white;
  border-radius: 20px;
  font-family: 'Poppins', sans-serif;
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 12px;
`;

const OrderCourseName = styled.h3`
  font-family: 'Poppins', sans-serif;
  font-size: 18px;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0 0 16px 0;
`;

const OrderDetailsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  gap: 12px;
  margin-bottom: 16px;
`;

const OrderDetailItem = styled.div`
  background: white;
  padding: 12px 16px;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
`;

const OrderDetailLabel = styled.p`
  font-family: 'Poppins', sans-serif;
  font-size: 11px;
  font-weight: 500;
  color: #9ca3af;
  margin: 0 0 4px 0;
  text-transform: uppercase;
`;

const OrderDetailValue = styled.p`
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #374151;
  margin: 0;
`;

const SelectedDatesContainer = styled.div`
  background: white;
  padding: 16px;
  border-radius: 12px;
  margin-bottom: 16px;
`;

const SelectedDatesTitle = styled.p`
  font-family: 'Poppins', sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  margin: 0 0 12px 0;
`;

const SelectedDatesList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const SelectedDateItem = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  font-family: 'Poppins', sans-serif;
  font-size: 13px;
  color: #4b5563;
`;

const DateBullet = styled.div`
  width: 8px;
  height: 8px;
  background: linear-gradient(135deg, #1a73e8 0%, #0d5bba 100%);
  border-radius: 50%;
`;

const PriceSummary = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 16px;
  border-top: 2px dashed #e5e7eb;
`;

const PriceLabel = styled.span`
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #6b7280;
`;

const PriceValue = styled.span`
  font-family: 'Poppins', sans-serif;
  font-size: 24px;
  font-weight: 700;
  color: #1a73e8;
`;

// Member Selection Styles
const MemberCardsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const MemberCard = styled.button`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px;
  background: ${props => props.$active ? 'linear-gradient(135deg, #f0f7ff 0%, #e0edff 100%)' : '#f9fafb'};
  border: 2px solid ${props => props.$active ? '#1a73e8' : 'transparent'};
  border-radius: 16px;
  cursor: pointer;
  transition: all 0.2s ease;
  width: 100%;
  text-align: left;

  &:hover {
    background: ${props => props.$active ? 'linear-gradient(135deg, #f0f7ff 0%, #e0edff 100%)' : '#f3f4f6'};
    transform: translateY(-1px);
  }
`;

const MemberAvatar = styled.div`
  width: 48px;
  height: 48px;
  background: ${props => props.$active ? 'linear-gradient(135deg, #1a73e8 0%, #0d5bba 100%)' : 'linear-gradient(135deg, #9ca3af 0%, #6b7280 100%)'};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
  font-weight: 700;
  color: white;
  flex-shrink: 0;
`;

const MemberInfo = styled.div`
  flex: 1;
  min-width: 0;
`;

const MemberName = styled.p`
  font-family: 'Poppins', sans-serif;
  font-size: 15px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0 0 4px 0;
`;

const MemberDetails = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: 'Poppins', sans-serif;
  font-size: 13px;
  color: #6b7280;
`;

const MemberDot = styled.div`
  width: 4px;
  height: 4px;
  background: #9ca3af;
  border-radius: 50%;
`;

const MemberCheck = styled.div`
  width: 28px;
  height: 28px;
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

// Modern Footer
const ModernFooter = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 16px 20px;
  background: white;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.08);
  z-index: 1000;
`;

const ConfirmButton = styled.button`
  width: 100%;
  padding: 16px 24px;
  background: linear-gradient(135deg, #1a73e8 0%, #0d5bba 100%);
  color: white;
  border: none;
  border-radius: 14px;
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 24px rgba(26, 115, 232, 0.35);
  }

  &:active {
    transform: translateY(0);
  }

  svg {
    transition: transform 0.3s ease;
  }

  &:hover svg {
    transform: translateX(4px);
  }
`;
